const operationPackageInstanceEn = {
  action: {
    approveAll: 'Approve all',
    approveAllSuccess: 'Approved all successfully',
    archive: 'Archive',
    archiveSuccess: 'Archived successfully',
    cannotApproveAll: 'Cannot approve all because there are no waiting approval tasks'
  },
  approvalAdmin: {
    cancel: 'Cancel',
    currentAssignee: 'Assignee: {{name}}',
    dialogTitle: 'Assign / Unassign approver',
    errors: {
      conflict: 'This action failed due to a concurrent update. The data was refreshed—please try again.',
      forbidden: 'You do not have permission to perform this action.',
      notFound: 'The ticket was not found. Refresh the page or open the task again.'
    },
    noAssignee: 'No assignee',
    nominate: 'Assign (admin)',
    nominateConfirm: 'Assign',
    nominateDescriptionOptional: 'Choose a candidate to assign, or unassign the current assignee. This is an administrative action.',
    nominateDescriptionRequired: 'This step requires an assignee. Choose a candidate to assign.',
    nominateEmpty: 'No candidates found',
    nominatePlaceholder: 'Select a person',
    nominateSearchPlaceholder: 'Search by name',
    nominateSuccess: 'Approver assigned.',
    returnHistoryCount: '{{count}} send-back(s)/pull-back(s)',
    revoke: 'Unassign',
    revokeConfirm: 'Unassign',
    revokeDialogDescription: 'Unassign {{name}} as the approver for this step?',
    revokeDialogDescriptionFallback: 'Remove the current assignee from this approval step?',
    revokeDialogTitle: 'Remove assignment',
    revokeSuccess: 'Assignment removed.'
  },
  archiveDialog: {
    confirmButton: 'Archive',
    description: 'All tasks, including those in progress, will be stopped and cannot be resumed. Data that has already been entered will be retained, but no further task execution will be possible. This action cannot be undone.',
    title: 'Archive this operation package?'
  },
  designation: {
    clearSelection: 'Clear selected member',
    confirmAndSubmit: 'Designate & Submit',
    designateFailed: 'Failed to designate approver. Please try again.',
    dialogDescription: 'Select approvers for the following approval tasks before submitting.',
    dialogTitle: 'Designate Approvers',
    noSearchResult: 'No matching people found',
    required: 'Required',
    searchPlaceholder: 'Search by name',
    selectPlaceholder: 'Select an approver',
    stageLabel: 'Approval step {{index}}'
  },
  tableHeader: {
    confirmScreenNavigation: 'Open confirmation screen',
    progress: 'Progress',
    requestedFor: 'Requested for'
  },
  task: {
    assignee: 'Assignee',
    deadline: 'Deadline',
    target: 'Target'
  },
  todoTask: {
    completed: 'Task completed successfully',
    markAsComplete: 'Mark as complete'
  }
};
export default operationPackageInstanceEn;